module.exports = __webpack_public_path__ + "static/media/fg-priceplus-front.19cb3e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg-priceplus-front.jpg
// module id = 344
// module chunks = 0